<template>
	<div v-if="error">{{ error }}</div>
	<div class="go-back">
		<a @click="$router.go(-1)"><i class="fad fa-long-arrow-left fa-lg"></i> Go Back</a>
		<i class="fad fa-chalkboard-teacher fa-lg"></i>
	</div>
	<div v-if="mentor" class="mentor">
		<h1>{{ mentor['name-last']}}, {{ mentor['name-first']}}</h1>
		<form v-on:submit.prevent="updateMentor">
			<fieldset>
				<legend>General</legend>
				<div class="label-field">
					<label for="first-name">First Name</label>
					<input id="first-name" type="text" required v-model="mentor['name-first']" />
				</div>
				<div class="label-field">
					<label for="last-name">Last Name</label>
					<input id="last-name" type="text" required v-model="mentor['name-last']">
				</div>
				<div class="label-field">
					<label for="email">Email</label>
					<input id="email" type="email" required v-model="mentor['email']">
				</div>
				<div class="label-field">
					<label for="bio">Bio</label>
					<textarea id="bio" rows="5" v-model="mentor['bio']"></textarea>
				</div>
				<div class="label-field">
					<label>DOB</label>
					<div class="field-group">
						<select id="month" v-model="mentor['dob-month']">
							<option>Month</option>
							<option v-for="m in 12" :key="m" :value="m">{{m}}</option>
						</select>
						<span> / </span>
						<select id="day" v-model="mentor['dob-day']">
							<option>Day</option>
							<option v-for="d in 31" :key="d" :value="d">{{d}}</option>
						</select>
					</div>
				</div>
				<div class="label-field">
					<label for="address">Address</label>
					<input id="address" type="text" required v-model="mentor['address']">
				</div>
				<div class="label-field">
					<label for="city">City</label>
					<input id="city" type="text" required v-model="mentor['city']">
				</div>
				<div class="label-field">
					<label for="state">State</label>
					<input id="state" class="inp-sm" type="text" size="2" maxlength="2" required v-model="mentor['state']">
				</div>
				<div class="label-field">
					<label for="zip">Zip</label>
					<input id="zip" class="inp-sm" type="text" size="10" maxlength="10" required v-model="mentor['zip']">
				</div>
			</fieldset>
			<fieldset>
				<legend>Social</legend>
				<div class="label-field">
					<label for="website">Website</label>
					<input id="website" type="text" placeholder="your-website-url.com" v-model="mentor['website']">
				</div>
				<div class="label-field">
					<label for="instagram">Instagram</label>
					<div class="field-group">
						<span>@</span>
						<input type="text" v-model="mentor['instagram']">
					</div>
				</div>
			</fieldset>
			<fieldset>
				<legend>Personal</legend>
				<div class="label-field">
					<label for="fact">Fun Fact</label>
					<input id="fact" type="text" required v-model="mentor['fact']">
				</div>
				<div>
					<ul class="all-files">
						<li v-for="file in mentor['headshots']" :key="file">
							<img :src="'https://ucarecdn.com/' + file + '/-/resize/210x/-/quality/lightest/'" />
							<ul class="file-utility">
								<li>
									<button @click="removeFile(file,'headshots')">
										<i class="fad fa-minus-circle"></i>
									</button>
								</li>
								<li>
									<a target="_blank" :href="'https://ucarecdn.com/' + file + '/'" class="button"><i class="fad fa-external-link fa-lg"></i></a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="label-field file-u">
					<label for="file-headshot">Headshot</label>
					<input id="file-headshot" type="hidden" role="uploadcare-uploader" name="file-headshot" data-multiple="true" data-tabs="file url camera" />
				</div>

				<div>
					<ul class="all-files">
						<li v-for="file in mentor['photos']" :key="file">
							<img :src="'https://ucarecdn.com/' + file + '/-/resize/210x/-/quality/lightest/'" />
							<ul class="file-utility">
								<li>
									<button @click="removeFile(file,'photos')">
										<i class="fad fa-minus-circle"></i>
									</button>
								</li>
								<li>
									<a target="_blank" :href="'https://ucarecdn.com/' + file + '/'" class="button"><i class="fad fa-external-link fa-lg"></i></a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="label-field file-u">
					<label for="file-photo">Lifestyle/Performance</label>
					<input id="file-photo" type="hidden" role="uploadcare-uploader" name="file-photo" data-multiple="true" data-tabs="file url camera" />
				</div>

				<div>
					<ul class="all-files">
						<li v-for="file in mentor['resumes']" :key="file">
							<i class="fad fa-file-user fa-6x"></i>
							<ul class="file-utility">
								<li>
									<button @click="removeFile(file,'resumes')">
										<i class="fad fa-minus-circle"></i>
									</button>
								</li>
								<li>
									<a target="_blank" :href="'https://ucarecdn.com/' + file + '/'" class="button"><i class="fad fa-external-link fa-lg"></i></a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="label-field file-u">
					<label for="file-resume">Resume (optional)</label>
					<input id="file-resume" type="hidden" role="uploadcare-uploader" name="file-resume" data-multiple="true" data-tabs="file url" />
				</div>
			</fieldset>
			<fieldset>
				<legend>Sessions</legend>
				<ul>
					<li v-for="session in sessions" :key="session.id">
						<div class="checkbox-group">
							<input type="checkbox" :id="session.id" :value="session.id" v-model="mentor['sessions']" />
							<label :for="session.id">{{ session.label }}</label>
						</div>
					</li>
				</ul>
			</fieldset>
			<fieldset>
				<legend>Contracts</legend>
				<ul>
					<li>
						<div class="checkbox-group">
							<input type="checkbox" id="individual" value="individual" v-model="mentor['contracts']" />
							<label for="individual">Individual</label>
						</div>
					</li>
					<li>
						<div class="checkbox-group">
							<input type="checkbox" id="joint" value="joint" v-model="mentor['contracts']" />
							<label for="joint">Joint</label>
						</div>
					</li>
				</ul>
			</fieldset>
			<fieldset>
				<legend>Internal Notes</legend>
				<div class="label-field">
					<label for="notes">Notes</label>
					<textarea id="notes" rows="5" v-model="mentor['notes']"></textarea>
				</div>
			</fieldset>
			<div class="submit-group">
				<button type="submit" :disabled="loading">
					<span v-if="!loading">Update</span>
					<span v-else>Loading&hellip;</span>
				</button>
			</div>
		</form>
	</div>
	<div v-else>
	<Spinner />
	</div>
</template>

<script>
import { ref, computed, onUpdated } from 'vue'
import getMentor from '../composables/getMentor'
import { useRoute, useRouter } from 'vue-router'
import { projectFirestore, timestamp } from '../firebase/config'
import uploadcare from 'uploadcare-widget'

import Spinner from '../components/Spinner.vue'

export default {
	props: ['id'],
	components: { Spinner },
	setup(props) {

		let 
			headshots = ref([]),
			photos = ref([]),
			resumes = ref([]),
			loading = ref(false)

		const route = useRoute()
		const { error, mentor, load } = getMentor(route.params.id)
		const router = useRouter()

		const sessions = computed(() => {
			const startYear = 2021
			const endYear = new Date().getFullYear() + 1
			const list = []
			for (let year = startYear; year <= endYear; year++) {
				list.push({ id: `${year}-Spring`, label: `Spring ${year}` })
				list.push({ id: `${year}-Fall`, label: `Fall ${year}` })
			}
			return list
		})

		function removeFile(which, arg2) {
			mentor.value[arg2] = mentor.value[arg2].filter(fileID => fileID !== which)
		}

		let updated_view = false

		function photoUpload(arg1, arg2) {
			arg1.onUploadComplete(function (fileInfo) {
				fetch('https://upload.uploadcare.com/group/info/?pub_key=e72e43c77015616a3bb3&group_id=' + fileInfo.uuid)
				.then(res => {
					res.json().then(function(data) {
						for (const file of data.files) {
							arg2.value.push(file.file_id)
						}
					});
				})
			});
		}

		onUpdated(() => {
			if (!updated_view) {
				if (document.getElementsByClassName("uploadcare--widget_status_ready").length == 0) {
					var widget_file_headshot = uploadcare.Widget('[id=file-headshot]')
						photoUpload(widget_file_headshot, headshots)

					var widget_file_photo = uploadcare.Widget('[id=file-photo]')
						photoUpload(widget_file_photo, photos)

					var widget_file_resume = uploadcare.Widget('[id=file-resume]')
						photoUpload(widget_file_resume, resumes)
				}
			}
			updated_view = true;
		})

		const updateMentor = async () => {

			loading.value = true

			mentor.value['headshots'] = mentor.value['headshots'] || []
			mentor.value['photos'] = mentor.value['photos'] || []
			mentor.value['resumes'] = mentor.value['resumes'] || []

			if (headshots.value.length > 0) {
				headshots.value.forEach(item => mentor.value['headshots'].push(item))
			}

			if (photos.value.length > 0) {
				photos.value.forEach(item => mentor.value['photos'].push(item))
			}

			if (resumes.value.length > 0) {
				resumes.value.forEach(item => mentor.value['resumes'].push(item))
			}

			let mentorData = {
				"name-first": mentor.value['name-first'] || '',
				"name-last": mentor.value['name-last'] || '',
				email: mentor.value['email'] || '',
				bio: mentor.value['bio'] || '',
				"dob-month": mentor.value['dob-month'] || '',
				"dob-day": mentor.value['dob-day'] || '',
				address: mentor.value['address'] || '',
				city: mentor.value['city'] || '',
				state: mentor.value['state'] || '',
				zip: mentor.value['zip'] || '',
				website: mentor.value['website'] || '',
				instagram: mentor.value['instagram'] || '',
				fact: mentor.value['fact'] || '',
				headshots: mentor.value['headshots'],
				photos: mentor.value['photos'],
				resumes: mentor.value['resumes'],
				sessions: mentor.value['sessions'] || [],
				contracts: mentor.value['contracts'] || [],
				notes: mentor.value['notes'] || '',
				"created-at": mentor.value['created-at'] || '',
				"updated-at": timestamp()
			}

			await projectFirestore.collection('mentors').doc(props.id).update(mentorData).then(() => {
				alert('Form Updated 😀');
				loading.value = false
				headshots.value = []
				photos.value = []
				resumes.value = []
			}).catch(err => {
				console.log(err)
			})

		}

		load()

		return { error, mentor, updateMentor, removeFile, onUpdated, loading, sessions }
	},
}
</script>